export default "__VITE_ASSET__B84q4xN5__"